<!-- Cabecera de botones -->
<div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enabled}">
  <form [formGroup]='formHeader' novalidate>
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col dato" style="max-width: 120px;">
          <Strong class="title">Rut recaudador</Strong>
          <span class="value">{{ usuarioDeclaracionRutFormato | rut }}</span>
        </div>
        <div class="col dato" style="max-width: 200px;">
          <Strong class="title">Nombre recaudador</Strong>
          <span class="value">{{ usuarioDeclaracionNombre }}</span>
        </div>
        <div class="col dato" style="max-width: 110px;">
          <Strong class="title">Fecha</Strong>
          <span class="value">{{dateTime | date }}</span>
        </div>
        <div class="col" style="max-width: 350px;">
          <div class="row filtros-body">
            <div class="col p-0" style="max-width: 150px;">
              <h5 class="m-0">¿Quién declara?</h5>
            </div>
          </div>
          <div class="row filtros-body">
            <div class="col p-0">
              <!-- Material inline 1 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="rb_vendedor" mdbInput formControlName="declararPor"
                  [value]="TIPO_DECLARANTE_VENDEDOR" />
                <label class="form-check-label" for="rb_vendedor">Vendedor</label>
              </div>


            </div>

            <div class="col p-0">
              <!-- Material inline 2 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="rb_cliente" mdbInput formControlName="declararPor"
                  [value]="TIPO_DECLARANTE_CLIENTE" />
                <label class="form-check-label" for="rb_cliente">Cliente</label>
              </div>


            </div>
            <div class="col p-0">
              <!-- Material inline 3 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="rb_otro" mdbInput formControlName="declararPor"
                  [value]="TIPO_DECLARANTE_OTRO" />
                <label class="form-check-label" for="rb_otro">Otro</label>
              </div>
            </div>


          </div>
        </div>
        <div class="col" style="max-width: 130px;">
          <div class="md-form">
            <input value="" type="text" id="rutdeclara" class="form-control" placeholder="" required #rutdeclara
              formControlName="rutDeclarante" formatRut />
            <label for="rutdeclara">RUT</label>
            <div *ngIf="
                                            formHeader.get('rutDeclarante').invalid &&
                                            (formHeader.get('rutDeclarante').dirty ||
                                            formHeader.get('rutDeclarante').touched)
                                        ">
              <mdb-error *ngIf="formHeader.get('rutDeclarante').hasError('required')">
                Ingrese rut declarante
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col d-flex" *ngIf="formHeader.get('declararPor').value === TIPO_DECLARANTE_VENDEDOR">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarVendedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ vendedorSeleccionado?.nombre }}
          </h6>
        </div>
        <div class="col d-flex" *ngIf="formHeader.get('declararPor').value === TIPO_DECLARANTE_CLIENTE">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ clienteSeleccionado?.razon_social }}
          </h6>
        </div>
        <div class="col d-flex md-form"
          *ngIf="formHeader.get('declararPor').value === TIPO_DECLARANTE_CLIENTE && clienteSeleccionado != null">
          <h6 style="display: contents;">
            Cond. pago: {{ clienteSeleccionado?.condicion_pago }}
          </h6>
        </div>
      </div>


    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <div>
        <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect (click)="clearData()">
          Limpiar
        </button>
        <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="realizarPago()">
          Realizar pago
        </button>
      </div>
    </div>
  </form>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="CLIENTE_CON_DEUDA" [permitirVisualizarClienteSinDeuda]="true"
  [ocultarColumnaSucursal]="true"
  (onSelectSingle)="onClienteSeleccionado($event)" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>